import { useStore, State } from 'store';

const selector = (state: State) => {
  return state.startWorkflow.submit;
};

export default function useSubmitState() {
  return useStore(selector);
}
